const EPSILON = 0.001;

export const EDITORIAL_READER_GEOMETRY = Object.freeze({
  desktopCanvasPx: 1200,
  desktopImageMaxPx: 680,
  mobileImageMaxPx: 420,
  bodyMeasureCh: 62,
});

export function hasExplicitEditorialCrop(media = {}) {
  const focalX = Number(media.focal_x ?? 0.5);
  const focalY = Number(media.focal_y ?? 0.5);
  const zoom = Number(media.zoom ?? 1);
  return Math.abs(focalX - 0.5) > EPSILON
    || Math.abs(focalY - 0.5) > EPSILON
    || Math.abs(zoom - 1) > EPSILON;
}

export function editorialImageStyle(media = {}, { intentionalCrop = false } = {}) {
  const focalX = Number(media.focal_x ?? 0.5);
  const focalY = Number(media.focal_y ?? 0.5);
  const zoom = Number(media.zoom ?? 1);
  const cropped = intentionalCrop || hasExplicitEditorialCrop(media);

  return {
    objectFit: cropped ? "cover" : "contain",
    objectPosition: `${focalX * 100}% ${focalY * 100}%`,
    transform: cropped ? `scale(${zoom})` : "none",
    transformOrigin: `${focalX * 100}% ${focalY * 100}%`,
  };
}

export function selectEditorialImage(primary, mobile, mode) {
  if (mode === "mobile" && mobile?.url) return mobile;
  return primary;
}
